import _ from "lodash"

// (earlier version retained for reference)
//
// export default class BinaryChop {
//
//     static lowerBoundInexact<T>(data: T[], value: number, predicate: (val: T) => number): number {
//         // https://en.wikipedia.org/wiki/Binary_search_algorithm
//         let l = 0
//         let r = data.length - 1
//         let m = -1
//         while(l < r) {
//             m = _.floor((l + r)/2)
//             if(m + 1 < data.length && predicate(data[m+1]) <= value) {
//                 // middle value is too small
//                 l = m + 1
//             } else if (predicate(data[m]) > value) {
//                 // middle value too big
//                 r = m - 1
//             } else {
//                 return m
//             }
//         }
//         return (l === r) ? l : -1
//     }    
// }


// function assertIsNum (n: number, msg: string) { 
//     if (isNaN(n)) throw new Error (msg)
// }

/**
 * Derived originally from the Binary Chop at https://en.wikipedia.org/wiki/Binary_search_algorithm (see earlier version above) but modified:
 * - to tolerate NaN values within the [ordered] data series
 * - to find the nearest data point where predicate()==value (the original found the data point to the immediate left)
 * Because: NaN values delimit sections of the route that lie outside the visible map extent, and therefore adjacent 
 * visible sections could be a considerable distance apart. The algorithm that splits the routein this way should not 
 * result in NaN values atthe start or end of the data series, and should not have consecutive NaN values within it.
 */
export default function findNearestDataPoint<T> (data: T[], value: number, predicate: (val: T) => number): number {
    
    // assertIsNum (predicate(data[0]), "The first & last items in the data series should not be NaN (first)")
    // assertIsNum (predicate(data[data.length-1]), "The first & last items in the data series should not be NaN (last)")

    let l = 0, r = data.length - 1

    for (;;) {
        if (r == l) return l;

        let m = _.floor((l + r)/2)
        let vm = predicate(data[m]); 

        if ((r - l == 1) || (r - l == 2 && isNaN(vm))) { // r and l are adjacent, or separated by a NaN
            let vl = predicate(data[l]); vl = isNaN(vl) ? predicate(data[--l]) : vl
            let vr = predicate(data[r]); vr = isNaN(vr) ? predicate(data[++r]) : vr
            // assertIsNum (vl, "The data series should not contain consecutive NaNs (L)")
            // assertIsNum (vr, "The data series should not contain consecutive NaNs (R)")
            return ((value - vl) <= (vr - value)) ? l : r // ie whichever of r and l is closest
        }
        
        vm = isNaN(vm) ? predicate(data[++m]) : vm
        // assertIsNum (vm, "The data series should not contain consecutive NaNs (M)")

        if (value >= vm) l = m
        if (value <= vm) r = m
        
    }
}    

